import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '../../../services/snackbar.service';
import { BlacklistService } from '../../../services/blacklist.service';
import { catchError, of } from 'rxjs';
import { DATE_SLASH_FORMAT } from '../../../core/formatting/date-formatting';
import { Moment } from 'moment';

export interface DeleteBlacklistDialogData {
  id: string;
  reason: string;
  date: Moment;
}

@Component({
  selector: 'app-delete-blacklist-item-dialog',
  templateUrl: './delete-blacklist-item-dialog.component.html',
  styleUrls: ['./delete-blacklist-item-dialog.component.scss'],
})
export class DeleteBlacklistItemDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<DeleteBlacklistItemDialogComponent>,
    private snackbarService: SnackbarService,
    private blacklistService: BlacklistService,
    @Inject(MAT_DIALOG_DATA) public data: DeleteBlacklistDialogData
  ) {}

  onDeleteClicked(): void {
    let id = this.data.id;
    let reason = this.data.reason;
    let date = this.data.date;
    this.blacklistService
      .deleteBlacklistItem$(id)
      .pipe(
        catchError(() => {
          this.snackbarService.error(`”${reason} - ${this.formatDate(date)}” törlése során hiba lépett fel!`);
          this.dialogRef.close({ success: false });
          return of();
        })
      )
      .subscribe(() => {
        this.snackbarService.success(`”${reason} - ${this.formatDate(date)}” sikeresen törölve a feketelistáról!`);
        this.dialogRef.close({ success: true });
      });
  }

  formatDate(date: Moment) {
    return date.format(DATE_SLASH_FORMAT);
  }
}
